import { ComponentBase } from './component-base';

export class InteractiveSpriteComponentBase extends ComponentBase {

    keyDown(e: KeyboardEvent) {
        if(e.keyCode === 27){
        this.disable();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/interactive-sprite-component-base.ts